import React from 'react';
import './Animation.css';

function Animation()
{
    return(
        <div className="animation-heading-container">
            <div className="animation-figure">
              <img className="holding-hands-img"src="https://ak.picdn.net/shutterstock/videos/1028380610/thumb/3.jpg?ip=x480"></img>
            </div>
        </div>
    )
}
export default Animation;
